'use client'

import Link from 'next/link'
import { useTranslations } from 'next-intl'
import { Repeat } from 'lucide-react'
import { VideoButton } from './VideoButton'
import { ScreenshotZoom } from './ScreenshotZoom'
import { CheckMark } from './CheckMark'

interface FeatureRoutinesProps {
  hideVideoButton?: boolean
}

const BULLET_KEYS = ['bullet1', 'bullet2', 'bullet3', 'bullet4', 'bullet5'] as const

export function FeatureRoutines({ hideVideoButton }: FeatureRoutinesProps = {}) {
  const t = useTranslations('features.routines')
  return (
    <div className="flex flex-col gap-[20px]">
      {/* Main feature row */}
      <div className="flex flex-wrap gap-[16px] items-start">
        {/* Phone screenshot (clickable) */}
        <ScreenshotZoom src="/images/feature-routines.png" alt={t('imageAlt')} />

        {/* Content */}
        <div className="flex flex-col gap-[6px] flex-1 min-w-0 break-words hyphens-auto">
          {/* Icon */}
          <div className="w-[24px] h-[24px]">
            <Repeat size={24} strokeWidth={2} className="text-[#6B8E6B]" />
          </div>

          {/* Text */}
          <div className="flex flex-col gap-[4px] pt-[2px]">
            <Link href="/features/routines" className="text-xl font-bold">{t('title')}</Link>
            <p className="text-l">
              {t('desc')}
            </p>
          </div>

          {/* Video button */}
          {!hideVideoButton && <VideoButton videoId="routines" className="mt-[8px]" />}

          {/* Zoom button */}
        </div>
      </div>

      {/* Checklist */}
      <div className="flex flex-col gap-[20px] mt-[8px]">
        {BULLET_KEYS.map((key) => (
          <div key={key} className="flex gap-[12px] items-start">
            <div className="shrink-0">
              <CheckMark size={28} color="#6B8E6B" />
            </div>
            <p className="text-l">
              {t.rich(key, { b: (chunks) => <strong>{chunks}</strong> })}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
